import { SVGFC } from '@repo/toolkit/types'

const SyncIcon: SVGFC = (props) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12069_48228)">
        <path
          d="M1.96935 5.00045C1.96935 3.54094 3.01551 2.34466 4.39243 2.06163V2.57737L6.20974 1.36584L4.39243 0.154297V0.811684C2.34123 1.10714 0.757812 2.86899 0.757812 5.00045C0.757812 6.28386 1.3333 7.43366 2.23722 8.21194L3.29798 7.50472C2.49696 6.95911 1.96935 6.04051 1.96935 5.00045Z"
          fill={props.color ?? 'white'}
        />
        <path
          d="M7.76161 1.79004L6.70085 2.49727C7.50188 3.04288 8.02948 3.96148 8.02948 5.00153C8.02948 6.46286 6.98543 7.67529 5.60637 7.95798V7.42457L3.78906 8.63611L5.60637 9.84765V9.1927C7.65779 8.89718 9.24102 7.13318 9.24102 5.00153C9.24102 3.71812 8.66553 2.56833 7.76161 1.79004Z"
          fill={props.color ?? 'white'}
        />
      </g>
      <defs>
        <clipPath id="clip0_12069_48228">
          <rect
            width="9.69231"
            height="9.69231"
            fill={props.color ?? 'white'}
            transform="translate(0.152344 0.154297)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SyncIcon
